import { render, staticRenderFns } from "./BookButton.vue?vue&type=template&id=d67c11e4&"
import script from "./BookButton.vue?vue&type=script&lang=ts&"
export * from "./BookButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports